module.exports = __webpack_public_path__ + "assets/img/Audi_S3_Banner_Desktop_20210223_V5.bff1c03.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/picture/Audi_S3_Banner_Desktop_20210223_V5.jpg
// module id = h65r
// module chunks = 1